import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        drlRequirement: '<',
        onClose: '&',
        onUpdate: '&'
    },
    template: `
            <div class="modal-header">
                <button type="button" class="close" ng-click="vm.onClose()"></button>
                <h2>{{ 'user.Add requirement' | translate }}</h2>
            </div>
            <form ng-submit="vm.save()" class="form">
                <div class="modal-body">
                    <div class="alert alert-plain">
                        <p>{{ 'user.Adding requirements for the following set: ' | translate }} <strong>{{ vm.drlRequirement.departmentName }}</strong></p>
                    </div>
                    <ul class="items06 type02">
                        <li ng-repeat="(key, item) in vm.models.list">
                            <div class="form">
                                <form-row error="vm.form.errors.competences[key].competenceId">
                                    <label class="label">{{ 'user.Competence' | translate }}</label>
                                    <div class="items">
                                        <select class="form-control" ng-change="vm.updateSkills()" ng-model="vm.form.model.competences[key].competenceId">
                                            <option value=""></option>
                                            <option value="{{ item.id }}" ng-repeat="item in vm.competences">
                                               {{ item.name }}
                                            </option>
                                        </select>
                                        <form-row-error></form-row-error>
                                    </div>
                                </form-row>
                                <form-row error="vm.form.errors.competences[key].type">
                                    <label class="label">Type</label>
                                    <div class="items">
                                        <ul class="checkboxes">
                                            <li>
                                                <label>
                                                <input
                                                     ng-model="vm.form.model.competences[key].type"
                                                     type="radio"
                                                     value="{{ vm.USER_COMPETENCE_REQUIREMENT_COMPETENCE_TYPE_ENUM.KEYS.MANDATORY }}">
                                                    {{ vm.USER_COMPETENCE_REQUIREMENT_COMPETENCE_TYPE_ENUM.LABELS.MANDATORY }}
                                                </label>
                                                <label>
                                                    <input
                                                     ng-model="vm.form.model.competences[key].type"
                                                     type="radio"
                                                     value="{{ vm.USER_COMPETENCE_REQUIREMENT_COMPETENCE_TYPE_ENUM.KEYS.OPTIONAL }}">
                                                  {{ vm.USER_COMPETENCE_REQUIREMENT_COMPETENCE_TYPE_ENUM.LABELS.OPTIONAL }}
                                                </label>
                                            </li>
                                        </ul>
                                    </div>
                                </form-row>
                                <ul class="actions01">
                                    <li class="nomargin"><a class="btn delete" ng-click="vm.removeItem(key)">{{ 'general.Remove' | translate }}</a></li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                    <ul class="actions01">
                        <li><a class="btn add" ng-click="vm.addItem()">{{ 'user.Add competence' | translate }}</a></li>
                        <li><a class="btn view" ng-click="vm.toggleSkills()">{{ 'user.Show related skills' | translate }}</a></li>
                    </ul>
                    <div class="terms01" ng-if="vm.openSkillModal === true">
                        <form-row error="vm.form.errors.skills[index].level" ng-repeat="(index, competenceSkill) in vm.form.model.skills">
                            <label class="label">{{ competenceSkill.name }}</label>
                            <div class="items">
                                <input type="hidden" class="form-control" ng-value="competenceSkill.skillId" ng-model="vm.form.model.skills[index].skillId"/>
                                <input class="form-control" ng-model="vm.form.model.skills[index].level"/>
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                    </div>
                    <hr>
                    <div class="form">
                        <form-row error="vm.form.errors.addDefaultValue">
                            <span class="label">
                                {{ 'user.Use default value' | translate }}
                                <small>{{ 'user.If yes, employees that match the DRL will be given a default value for the new skills' | translate }}</small>
                            </span>
                            <div class="items">
                                <ul class="checkboxes">
                                    <li>
                                        <label>
                                            <input type="checkbox" name="r01" value="1" ng-model="vm.form.model.addDefaultValue">{{ 'general.Yes' | translate }}
                                        </label>
                                    </li>
                                </ul>
                            </div>
                        </form-row>
                    </div>
                </div>
                <div class="modal-footer">
                    <ul class="actions01">
                        <li class="primary"><button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button></li>
                        <li><button class="btn discrete" type="button" ng-click="vm.onClose()">{{ 'general.Cancel' | translate }}</button></li>
                    </ul>
                </div>
            </form>
    `
})
export default class {
    constructor (FormFactory, SkillResource, CompetenceResource, CompetenceRequirementResource, USER_COMPETENCE_REQUIREMENT_COMPETENCE_TYPE_ENUM, CLASSIFIER_ENUM) {
        this.FormFactory = FormFactory;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.USER_COMPETENCE_REQUIREMENT_COMPETENCE_TYPE_ENUM = USER_COMPETENCE_REQUIREMENT_COMPETENCE_TYPE_ENUM;
        this.CompetenceResource = CompetenceResource;
        this.SkillResource = SkillResource;
        this.CompetenceRequirementResource = CompetenceRequirementResource;
    }

    $onInit () {
        this.form = this.FormFactory.createFromResource(this.drlRequirement);

        this.models = {};
        this.models.list = [];
        this.form.model.competences = [];
        this.form.model.skills = [];
        this.addItem();

        this.CompetenceResource.query({ pageSize: 0 }).$promise.then((competences) => {
            this.competences = competences;
        });
    }

    save () {
        return this.form.save().then(() => {
            return this.onUpdate();
        });
    }

    removeItem (key) {
        if (this.models.list.length > 1) {
            this.models.list.splice(key, 1);
            this.form.model.competences.splice(key, 1);
            this.updateSkills();
        }
    }

    addItem () {
        this.models.list.push({});
    }

    toggleSkills () {
        this.openSkillModal = !this.openSkillModal;
    }

    updateSkills () {
        const searchParams = { 'competenceId[]': this.form.model.competences.map(item => item.competenceId), expand: 'competence,skill' };
        this.SkillResource.competenceSkills(searchParams).$promise.then(competenceSkills => {
            this.competenceSkills = competenceSkills;

            const duplicatedSkillIds = competenceSkills.filter((competenceSkill) => {
                return this.form.model.skills.map(item => item.skillId).indexOf(competenceSkill.skillId) !== -1;
            }).map(item => item.skillId);

            const newSkills = competenceSkills.filter(competenceSkill => duplicatedSkillIds.indexOf(competenceSkill.skillId) === -1);
            const oldSkills = this.form.model.skills.filter(editedSkill => duplicatedSkillIds.indexOf(editedSkill.skillId) !== -1);

            this.form.model.skills = oldSkills.concat(newSkills.map(item => ({ skillId: item.skillId, level: null, name: item.skill.name })));
            this.form.model.errors = {};
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/competence/requirements/addCompetence/index.js